module.exports = __webpack_public_path__ + "static/img/7.d5c3759.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/1/zh/7.png
// module id = 39FM
// module chunks = 0